export default "__VITE_ASSET__DBHgK4gI__"